import { AxiosInstance } from "axios";
import { FlowOfferData } from "../steps/cross-sell";

export const crossSellPaths = {
  getProductsByApplication: (applicationId: string) => `/onboarding-applications/${applicationId}/cross-sell/products`,
};

class CrossSellApi {
  api: AxiosInstance;

  constructor(api: AxiosInstance) {
    this.api = api;
  }

  getProductsByApplication = (applicationId: string, maxOffers?: number) => {
    const params = maxOffers ? { maxOffers } : {};
    return this.api.get<FlowOfferData[]>(crossSellPaths.getProductsByApplication(applicationId), { params });
  };
}

export default CrossSellApi;